import { filter, isNull } from "lodash";
import uuidv4 from "uuid/v4";

export default {
    beforeRouteLeave(to, from, next) {
        this.beforePaymentModalDestroyed();
    },
    created() {
        // Before the page reload, emit socket with empty invoiceIds to clear the warning message from the invoice page on other tabs
        window.addEventListener(
            "beforeunload",
            this.beforePaymentModalDestroyed
        );
    },
    beforeDestroy() {
        window.removeEventListener(
            "beforeunload",
            this.beforePaymentModalDestroyed
        );
    },
    data() {
        return {
            paymentModalId: null // The ID used to push into the paymentModalChooseThisInvoice in invoice.vue to display the warning message
        };
    },
    computed: {
        invoiceIds() {
            return filter(this.selectedInvoices, element => {
                return element.is_invoice == true;
            }).map(element => element.id);
        }
    },
    methods: {
        offListenToVBroadcast() {
            this.$socket.client.off("v-broadcast", this.handleVBroadcast);
        },
        onListenToVBroadcast() {
            this.$socket.client.on("v-broadcast", this.handleVBroadcast);
        },
        handleVBroadcast(payload) {
            if (payload.action === "payment:invoice-join") {
                this.socketPaymentInvoice(payload);
            }
        },
        setSocketPaymentModalId() {
            this.paymentModalId = uuidv4();
        },
        beforePaymentModalDestroyed() {
            if (
                typeof this.isPaymentModalShowing === "function" &&
                this.isPaymentModalShowing()
            ) {
                this.emitSocketInvoiceChanged([]);
            }
        },
        socketPaymentInvoice(payload) {
            if (
                this.invoiceIds.includes(payload.invoiceId) ||
                payload.isFromPaymentModal
            ) {
                this.emitSocketInvoiceChanged();
            }
        },
        emitSocketInvoiceChanged(invoiceIds = null) {
            if (isNull(invoiceIds)) {
                invoiceIds = this.invoiceIds;
            }
            this.$socket.client.emit("v-broadcast", {
                action: "payment:invoice-changed",
                invoiceIds: invoiceIds,
                businessId: this.$root.setting.business_id,
                userName: this.$root.currentActor.fullname,
                userId: this.$root.currentActor.id,
                paymentModalId: this.paymentModalId
            });
        },
        emitSocketInvoicePaid(invoiceIds) {
            if (Array.isArray(invoiceIds) && invoiceIds.length > 0) {
                this.$socket.client.emit("v-broadcast", {
                    action: "payment:invoice-paid",
                    invoiceIds: invoiceIds,
                    businessId: this.$root.setting.business_id,
                    userName: this.$root.currentActor.fullname,
                    userId: this.$root.currentActor.id,
                    paymentModalId: this.paymentModalId
                });
            }
        }
    }
};
